'use client';

import type { CSSProperties } from 'react';

/** Matches Containd PlaceholderChrome (DEC-062). */
export const PLACEHOLDER_STAMP_BG = 'rgba(220, 38, 127, 0.9)';
/** Grey stamp when the original is not in this share (no jump). */
export const PLACEHOLDER_UNLINKED_STAMP_BG = 'rgba(107, 114, 128, 0.9)';
export const PLACEHOLDER_UNLINKED_BORDER = '#6b7280';
export const PLACEHOLDER_UNLINKED_OPACITY = 0.75;

/** Absolute-positioned pink “Placeholder” stamp. */
export function PlaceholderChromeOverlay({
  visible = true,
  linked = true,
}: {
  visible?: boolean;
  linked?: boolean;
}) {
  if (!visible) return null;

  const style: CSSProperties = {
    position: 'absolute',
    top: 8,
    right: 8,
    backgroundColor: linked ? PLACEHOLDER_STAMP_BG : PLACEHOLDER_UNLINKED_STAMP_BG,
    paddingLeft: 6,
    paddingRight: 6,
    paddingTop: 2,
    paddingBottom: 2,
    borderRadius: 4,
    transform: 'rotate(15deg)',
    boxShadow: '1px 1px 2px rgba(0,0,0,0.3)',
    zIndex: 10,
    pointerEvents: 'none',
    color: '#ffffff',
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: 1,
    lineHeight: 1.2,
  };

  return (
    <div
      style={style}
      data-placeholder-stamp
      data-placeholder-unlinked={linked ? undefined : '1'}
    >
      Placeholder
    </div>
  );
}

/** Dashed outer border for placeholder seats (ItemCanvasElement parity). */
export function placeholderDashedBorderCss(
  frameThickness: number,
  borderColor?: string | null,
  linked = true,
): Pick<CSSProperties, 'borderStyle' | 'borderWidth' | 'borderColor'> {
  return {
    borderStyle: 'dashed',
    borderWidth: Math.max(2, frameThickness || 2),
    borderColor: linked
      ? borderColor || '#000000'
      : PLACEHOLDER_UNLINKED_BORDER,
  };
}
